import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickStartGuideExampleImage from "@/features/pathpick/features/start-guide/components/PathPickStartGuideExampleImage";
import { START_GUIDE_IMAGES } from "@/features/pathpick/features/start-guide/constants";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onNext: () => void;
}

/**
 * 스마트스토어 등록 예시 — API 연동 완료 후에만 연다.
 *
 * 관리자 화면 캡처가 가로로 길어 모달 폭을 넓게 잡고 내부 스크롤(최대 92vh)을 쓴다.
 * 스토어 노출 예시는 모바일 화면이라 가운데 정렬하고 420px로 제한한다(전달서 §11).
 */
function PathPickStartGuideRegistrationExampleModal({
  isOpen,
  onClose,
  onNext,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      minWidth={"min(960px, 92vw)"}
      maxWidth={"92vw"}
      maxHeight={"92vh"}
      scrollBehavior={"inside"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick_guide:registration_example.title")}
      />
      <CustomApprovalModal.Body overflow={"auto"}>
        <Flex flexDirection={"column"} gap={"20px"}>
          <Flex flexDirection={"column"} gap={"10px"}>
            <Text textStyle={"body-sm-medium"} color={"#444440"}>
              {t("path_pick_guide:registration_example.section_1")}
            </Text>
            {/* 관리자 화면은 좌우로 읽어야 해서 모달 전체 너비에 가깝게 둔다. */}
            <PathPickStartGuideExampleImage
              src={START_GUIDE_IMAGES.smartStoreRegistrationAdmin}
              alt={t(
                "path_pick_guide:registration_example.section_1_image_alt"
              )}
              placeholderHeight={"320px"}
            />
          </Flex>

          <Flex flexDirection={"column"} gap={"10px"}>
            <Text textStyle={"body-sm-medium"} color={"#444440"}>
              {t("path_pick_guide:registration_example.section_2")}
            </Text>
            <Flex justifyContent={"center"}>
              <PathPickStartGuideExampleImage
                src={START_GUIDE_IMAGES.smartStoreRegistrationProduct}
                alt={t(
                  "path_pick_guide:registration_example.section_2_image_alt"
                )}
                maxWidth={"420px"}
                placeholderHeight={"420px"}
              />
            </Flex>
          </Flex>

          <Flex justifyContent={"flex-end"} gap={"8px"}>
            <AppButton
              variant={"primary"}
              onClick={() => {
                onClose();
                onNext();
              }}
            >
              {t("path_pick_guide:nav.next_step")}
            </AppButton>
            <AppButton variant={"normal"} onClick={onClose}>
              {t("path_pick_guide:registration_example.close")}
            </AppButton>
          </Flex>
        </Flex>
      </CustomApprovalModal.Body>
    </CustomApprovalModal>
  );
}

export default PathPickStartGuideRegistrationExampleModal;
